import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full h-full flex flex-col items-center justify-center main-container" }
const _hoisted_2 = { class: "w-full h-full flex flex-col items-center justify-center bg-white py-24 gap-10" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", null, "Bulk Add Document", -1)

import firebase from "../../firebase";


export default /*#__PURE__*/_defineComponent({
  __name: 'BulkAddDocument',
  setup(__props) {


const documents = [
    {
        docType: "catalog",
        company: "Bosch",
        fileType: "pdf",
        year: 2024,
        title: "Bosch VRF Katalog",
        lang: "en",
        url: "https://drive.google.com/file/d/1TwijcD1DTFJLqQK5KiGnWO12F2BCp8N8/view?usp=drive_link",
        image: "https://www.dansuk.com.tr/wp-content/uploads/2026/01/Bosch-VRF-Katalog_rs.webp",
        subfolder: "Kataloglar",
    }, // start 2
    {
        docType: "certificate",
        company: "Bosch",
        fileType: "pdf",
        year: 2024,
        title: "Bosch CE Sertifika - AF2 IDU",
        lang: "en",
        url: "https://drive.google.com/file/d/1uNiFGo9r1psi2GGYFQ6s_Jj0wWbwjmfg/view?usp=drive_link",
        image: "https://www.dansuk.com.tr/wp-content/uploads/2026/01/CE-DoC_6721838359_Bosch_AF2_IDU_rs.webp",
        subfolder: "CE Sertifikaları",
    },
    {
        docType: "certificate",
        company: "Bosch",
        fileType: "pdf",
        year: 2024,
        title: "Bosch CE Sertifika - AF5301",
        lang: "en",
        url: "https://drive.google.com/file/d/1lrl_SWqctfnOJQLvyNGI-XOK5Y_YsVnO/view?usp=drive_link",
        image: "https://www.dansuk.com.tr/wp-content/uploads/2026/01/CE-DoC_6721838815_Bosch_AF5301-1_rs.webp",
        subfolder: "CE Sertifikaları",
    },
    {
        docType: "certificate",
        company: "Bosch",
        fileType: "pdf",
        year: 2024,
        title: "Bosch CE Sertifika - AF2 ID DH FC F (...)",
        lang: "en",
        url: "https://drive.google.com/file/d/1QGM6o6IbkmeDYL90skliocxj97qIPjRA/view?usp=drive_link",
        image: "https://www.dansuk.com.tr/wp-content/uploads/2026/01/CE-DoC_6721866817_Bosch_AF2_1D_DH_FC_F_4CS_DMS_CF_rs.webp",
        subfolder: "CE Sertifikaları",
    },
    {
        docType: "certificate",
        company: "Bosch",
        fileType: "pdf",
        year: 2024,
        title: "Bosch CE Sertifika - AF2-P 4CR, AF2-P 4CC",
        lang: "en",
        url: "https://drive.google.com/file/d/1EzuVdziykjoNcHu4hB0po5CE20Q9C07X/view?usp=drive_link",
        image: "https://www.dansuk.com.tr/wp-content/uploads/2026/01/CE-DoC_6721866822_Bosch_AF2-P-4CR-AF2-P-4CC_rs.webp",
        subfolder: "CE Sertifikaları",
    },
    {
        docType: "certificate",
        company: "Bosch",
        fileType: "pdf",
        year: 2024,
        title: "Bosch CE Sertifika - ARC L",
        lang: "en",
        url: "https://drive.google.com/file/d/1g1hYGdpbD28uZB8v_QCgWvxQ_M_mUJcE/view?usp=drive_link",
        image: "https://www.dansuk.com.tr/wp-content/uploads/2026/01/CE-DoC_6721866809_Bosch_ARC_L_rs.webp",
        subfolder: "CE Sertifikaları",
    }, // start 3

    {
        docType: "certificate",
        company: "Bosch",
        fileType: "pdf",
        year: 2025,
        title: "Bosch ISO 9001",
        lang: "en",
        url: "https://drive.google.com/file/d/1XhdviTwCXTv0KDez9oc4weTQV2qU5V7U/view?usp=drive_link",
        image: "https://www.dansuk.com.tr/wp-content/uploads/2026/01/ISO9001-1_rs.webp",
        subfolder: "ISO Sertifikaları",
    },
    {
        docType: "certificate",
        company: "Bosch",
        fileType: "pdf",
        year: 2025,
        title: "Bosch ISO 14001",
        lang: "en",
        url: "https://drive.google.com/file/d/1FyMoovzJoNNm6rbyTQ6saPvVRYsefy9Y/view?usp=drive_link",
        image: "https://www.dansuk.com.tr/wp-content/uploads/2026/01/ISO14001-1_rs.webp",
        subfolder: "ISO Sertifikaları",
    },
    {
        docType: "certificate",
        company: "Bosch",
        fileType: "pdf",
        year: 2025,
        title: "Bosch ISO 45001",
        lang: "en",
        url: "https://drive.google.com/file/d/1QPX3KfUZLjtjoeXnDJazvhrEYQ06T7dr/view?usp=drive_link",
        image: "https://www.dansuk.com.tr/wp-content/uploads/2026/01/ISO45001-1_rs.webp",
        subfolder: "ISO Sertifikaları",
    },
    {
        docType: "certificate",
        company: "Bosch",
        fileType: "pdf",
        year: 2025,
        title: "Bosch M&B ISO 9001",
        lang: "en",
        url: "https://drive.google.com/file/d/1XKd2TJBM4-PtwPUI5-59bZg2amsmfSAu/view?usp=drive_link",
        image: "https://www.dansuk.com.tr/wp-content/uploads/2026/01/MB-ISO9001-certificate_rs.webp",
        subfolder: "ISO Sertifikaları",
    }, // Start 4

    {
        docType: "certificate",
        company: "Bosch",
        fileType: "pdf",
        year: 2022,
        title: "Bosch Eurovent Sertifikası",
        lang: "en",
        url: "https://drive.google.com/file/d/1JCjhSK6Z2qZtAWm-QGfoqEPrUhxwD3ui/view?usp=drive_link",
        image: "https://www.dansuk.com.tr/wp-content/uploads/2026/01/VRF_certificate_rs.webp",
        subfolder: "Eurovent Sertifikaları",
    },
    {
        docType: "certificate",
        company: "Bosch",
        fileType: "pdf",
        year: 2026,
        title: "AF4300A 25-3 Eurovent Sertifikası",
        lang: "en",
        url: "https://drive.google.com/file/d/10F-WGtwxi168Na2U49U9BuVjdpzQchX_/view?usp=drive_link",
        image: "https://www.dansuk.com.tr/wp-content/uploads/2026/01/VRF-AF4300A-25-3-1767693639-65-3ae1d52c_rs.webp",
        subfolder: "Eurovent Sertifikaları",
    },
    {
        docType: "certificate",
        company: "Bosch",
        fileType: "pdf",
        year: 2026,
        title: "AF5301A C 28-3 Eurovent Sertifikası",
        lang: "en",
        url: "https://drive.google.com/file/d/1r851n_L0a-4DjARFIIhq5mGlg43WZ92V/view?usp=drive_link",
        image: "https://www.dansuk.com.tr/wp-content/uploads/2026/01/VRF-AF5301A-C-28-3-1767692272-88-49e74c4b_rs.webp",
        subfolder: "Eurovent Sertifikaları",
    },
    {
        docType: "certificate",
        company: "Bosch",
        fileType: "pdf",
        year: 2026,
        title: "AF5301A C 33-3 Eurovent Sertifikası",
        lang: "en",
        url: "https://drive.google.com/file/d/1DaPb_n6Lqh82BHUnT8hXY2PcJHk_Ir9P/view?usp=drive_link",
        image: "https://www.dansuk.com.tr/wp-content/uploads/2026/01/VRF-AF5301A-C-33-3-1767693035-02-4d21ff4d_rs.webp",
        subfolder: "Eurovent Sertifikaları",
    },
    {
        docType: "certificate",
        company: "Bosch",
        fileType: "pdf",
        year: 2026,
        title: "AF5301A C 40-3 Eurovent Sertifikası",
        lang: "en",
        url: "https://drive.google.com/file/d/183rwCb2GJthbbkArFZPo82qsSi7J67KK/view?usp=drive_link",
        image: "https://www.dansuk.com.tr/wp-content/uploads/2026/01/VRF-AF5301A-C-40-3-1767693176-0d-738639b7_rs.webp",
        subfolder: "Eurovent Sertifikaları",
    },
    {
        docType: "certificate",
        company: "Bosch",
        fileType: "pdf",
        year: 2026,
        title: "AF5301A C 45-3Eurovent Sertifikası",
        lang: "en",
        url: "https://drive.google.com/file/d/1OJueIuUiXXnxG9JMeOwrZPzpdiQ1ysDt/view?usp=drive_link",
        image: "https://www.dansuk.com.tr/wp-content/uploads/2026/01/VRF-AF5301A-C-45-3-1767693212-55-bca448ae_rs.webp",
        subfolder: "Eurovent Sertifikaları",
    },
    {
        docType: "certificate",
        company: "Bosch",
        fileType: "pdf",
        year: 2026,
        title: "AF5301A C 50-3 Eurovent Sertifikası",
        lang: "en",
        url: "https://drive.google.com/file/d/1I_fLh3QuhgbxaAhQuKXrWJXNma2Ns_AJ/view?usp=drive_link",
        image: "https://www.dansuk.com.tr/wp-content/uploads/2026/01/VRF-AF5301A-C-50-3-1767693245-07-3470438f_rs.webp",
        subfolder: "Eurovent Sertifikaları",
    },
    {
        docType: "certificate",
        company: "Bosch",
        fileType: "pdf",
        year: 2026,
        title: "AF5301A C 56-3 Eurovent Sertifikası",
        lang: "en",
        url: "https://drive.google.com/file/d/1giymGajdXJt-lj-92do4k2DhhTiAihll/view?usp=drive_link",
        image: "https://www.dansuk.com.tr/wp-content/uploads/2026/01/VRF-AF5301A-C-56-3-1767693274-a8-ebdf14ba_rs.webp",
        subfolder: "Eurovent Sertifikaları",
    },
    {
        docType: "certificate",
        company: "Bosch",
        fileType: "pdf",
        year: 2026,
        title: "AF5301A C 62-3 Eurovent Sertifikası",
        lang: "en",
        url: "https://drive.google.com/file/d/1bcAc7K1x4dhacEy0N2JLybXD_XM5YI_I/view?usp=drive_link",
        image: "https://www.dansuk.com.tr/wp-content/uploads/2026/01/VRF-AF5301A-C-62-3-1767693305-e0-515a138b_rs.webp",
        subfolder: "Eurovent Sertifikaları",
    },
    {
        docType: "certificate",
        company: "Bosch",
        fileType: "pdf",
        year: 2026,
        title: "AF5301A C 67-3 Eurovent Sertifikası",
        lang: "en",
        url: "https://drive.google.com/file/d/1kwz9bqOPgAXbLX9USo6eV8LjHAhQ6w1I/view?usp=drive_link",
        image: "https://www.dansuk.com.tr/wp-content/uploads/2026/01/VRF-AF5301A-C-67-3-1767693355-1d-37750b18_rs.webp",
        subfolder: "Eurovent Sertifikaları",
    },
]

const addDocuments = () => {
    for (const document of documents) {
        const docRef = firebase.firestore().collection("newDocs").doc();
        docRef.set(document);
    }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", null, _toDisplayString(documents.length), 1),
      _createElementVNode("button", {
        class: "ac-primary-button",
        onClick: addDocuments
      }, "Add Documents to the Databse")
    ])
  ]))
}
}

})